import React from 'react'
import { useDevice } from 'device'

import HowItWorksBlock from 'compositions/landings/HowItWorksBlock/HowItWorksBlock'

import GetStartedButton from '../GetStartedButton/GetStartedButton'


type HowItWorksSectionProps = {
  className?: string
  startButtonMessage?: string | Intl.Message
}

const HowItWorksSection: React.FunctionComponent<HowItWorksSectionProps> = ({ className, startButtonMessage }) => {
  const { isMobile } = useDevice()

  return (
    <HowItWorksBlock className={className}>
      <GetStartedButton
        className={isMobile ? 'mt-24' : 'mt-32'}
        title={startButtonMessage}
        width={320}
        fullWidthOnMobile
        placement="How it works"
      />
    </HowItWorksBlock>
  )
}


export default React.memo(HowItWorksSection)
